import * as React from 'react'
import { Link } from 'react-router-dom'
import styled, { css } from "styled-components"

const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  font-size: 14px;
  flex-wrap: wrap;
  gap: 8px;

  svg {
    width: 8px;
    height: 8px;
  }
`

const BreadCrumb = styled(Link) <{ active?: boolean }>`
  text-decoration: none;
  color: #1a1a1a;
  transition: all 0.15s linear;
  font-weight: 300;
  font-size: 13px;

  ${props => props.active && css`
    color: #737373;
    cursor: default;
  `}

  &:hover {
    color: #737373;
  }
`

interface IProps {
  breadcrumbs: {
    label: string
    to: string
  }[]
}

const Breadcrumbs = (props: IProps) => {
  const { breadcrumbs } = props
  return (
    <Container>
      {breadcrumbs.map((breadcrumb, index) => (<>
        <BreadCrumb key={breadcrumb.label} to={breadcrumb.to} active={breadcrumbs.length - 1 === index}>{breadcrumb.label}</BreadCrumb>
        {breadcrumbs.length - 1 > index && <svg key={`${index}-svg`} width="6" height="10" viewBox="0 0 6 10" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" clipRule="evenodd" d="M0.648862 0.898862C0.316916 1.23081 0.316916 1.769 0.648862 2.10094L3.54782 4.9999L0.648862 7.89886C0.316916 8.23081 0.316917 8.769 0.648862 9.10094C0.980808 9.43289 1.519 9.43289 1.85094 9.10094L5.35094 5.60094C5.68289 5.269 5.68289 4.73081 5.35094 4.39886L1.85094 0.898862C1.519 0.566916 0.980807 0.566916 0.648862 0.898862Z"></path></svg>}
      </>))}
    </Container>
  )
}

export default Breadcrumbs